import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["standing-seam-metal-roofing"];

export const Route = createFileRoute("/services/standing-seam-metal-roofing")({
  head: () => ({
    meta: [
      { title: "Standing Seam Metal Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Standing Seam Metal Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/standing-seam-metal-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
